import { Component } from '@angular/core';

@Component({
  selector: 'tw-not-found',
  imports: [],
  template: 'coming soon!',
})
export class NotFoundComponent {}
